import create from 'zustand/vanilla';
import createHook from 'zustand';

export const citySpecificOfflineCentreStore = create((set) => ({
  userLocation: null,
  isBatchesOnTop: false,
  imagesClicked: false,
  isBatchesVisibleZus: false,
  centreData: null,
  centresListData: [],
  isDemoClassesClicked: false,
  isScholarShipBlockClicked: false,
  isDownloadBrochureClicked: false,
  shiftCookiesBanner: false,
  centreListData: [],
  selectedCentreBEData: {},
  selectedCentreFound: false,
  setSelectedCentreFound: (data) => {
    set((state) => ({ ...state, selectedCentreFound: data }));
  },
  setCentreListData: (data) => {
    set((state) => ({ ...state, centreListData: data }));
  },

  setDownloadBrochureClicked: (value) => {
    set((state) => ({ ...state, isDownloadBrochureClicked: value }));
  },
  setScholarShipBlockClicked: (value) => {
    set((state) => ({ ...state, isScholarShipBlockClicked: value }));
  },
  setDemoClassesClicked: (value) => {
    set((state) => ({ ...state, isDemoClassesClicked: value }));
  },
  // Setting CMS centre Data
  setCentreData: (data) => {
    set((state) => ({
      ...state,
      centreData: data
    }));
  },
  setSelectedCentre: (data) => {
    set((state) => ({
      ...state,
      selectedCentreBEData: data
    }));
  },
  setCentresListData: (data) => {
    set((state) => ({
      ...state,
      centresListData: data
    }));
  },
  setUserLocation: (location) =>
    set((state) => ({
      ...state,
      userLocation: location
    })),
  setIsBatchesOnTop: (value) =>
    set((state) => ({
      ...state,
      isBatchesOnTop: value
    })),
  setImagesClicked: (value) =>
    set((state) => ({
      ...state,
      imagesClicked: value
    })),
  setIsBatchesVisibleZus: (value) =>
    set((state) => ({
      ...state,
      isBatchesVisibleZus: value
    })),
  setShiftCookiesBanner: (value) =>
    set((state) => ({
      ...state,
      shiftCookiesBanner: value
    }))
}));

const useCitySpecificiOfflineCentreStore = createHook(
  citySpecificOfflineCentreStore
);

export default useCitySpecificiOfflineCentreStore;
